
<template>
  <div>
    <Form style="margin: 30px 20px 0px 0px" :model="formItem" :label-width="100" label-position="left" :disabled="loading">
      <Row>
        <Col span="4">
          <FormItem label="所属页面：">
            <Select
                clearable
                v-model="formItem.viewType"
                placeholder=""
              >
                <Option
                  v-for="(item, index) in viewTypeList"
                  :value="item.code"
                  :key="index"
                  >{{ item.value }}</Option
                >
              </Select>
          </FormItem>
        </Col>
        <Col span="4" offset="1">
          <FormItem label="中文描述：">
            <Input v-model="formItem.chName" />
          </FormItem>
        </Col>
        <Col span="4" offset="1">
          <FormItem label="英文描述：">
            <Input v-model="formItem.enName" />
          </FormItem>
        </Col>
        <Col span="4" offset="1">
          <Button type="primary" @click = "total=0,pageInfo.pageNo=1,initgetData()"><!-- 检索 -->{{$t('Search')}}</Button>
        </Col>
      </Row>
    </Form>
      <Table border ref="table" :loading="loading"  :columns="internationalColumns" :data="internationalData"  width="100%" stripe> 
        <template slot-scope="{ row, index }" slot="action">
          <Button type="warning" icon="md-create" size="small" style="margin-right: 5px" @click="showInternationalOpen(row,index)">编辑</Button>
        </template>
      </Table>
      <Row style="margin-top:15px">
        <Col span="19">
          <Page :total="total" :page-size="pageInfo.pageSize" @on-change="pageChange" />
        </Col>
        <Col span="5">
          <Button type="primary" icon="md-add" style="float: right" :disabled="loading" @click="addViewSet">新增</Button>
        </Col>
      </Row>
    <Modal v-model="showInternational" title="编辑" width=400px> 
      <Form style="margin: 20px" :label-width="120" :modal="showFormItem" label-position="left"  >
        <Row>
          <FormItem label="所属页面：">
            <Select clearable disabled v-model="showFormItem.viewType" placeholder="" style="width:190px">
              <Option v-for="(item, index) in viewTypeList" :value="item.code" :key="index">{{ item.value }}</Option>
            </Select>
          </FormItem>

        </Row>
        <Row>
          <FormItem label="绑定key值：">
            <Input v-model="showFormItem.showKey" :disabled="true" />
          </FormItem>
        </Row>
        <Row>
          <FormItem label="中文描述：">
            <Input v-model="showFormItem.chName" />
          </FormItem>
        </Row>
        <Row>
          <FormItem label="英文描述：">
            <Input v-model="showFormItem.enName" />
          </FormItem>
        </Row>
        <!-- <Row>
          <FormItem label="显示角色：">
            <Input v-model="showFormItem.beShowRole" />
          </FormItem>
        </Row> -->
        <Row>
          <FormItem label="是否启用：">
            <Checkbox v-model="showFormItem.beUsed"></Checkbox>
          </FormItem>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" @click="cancelClose()">取消</Button>
        <Button type="primary" @click="confirmSave()">确定</Button>
      </div>
    </Modal>    
    <Modal v-model="showAddViewSet" title="新增" width=400px> 
      <Form style="margin: 20px" :label-width="120" :modal="addObject" label-position="left"  >
        <Row>
          <FormItem label="所属页面：">
            <Select clearable v-model="addObject.viewType" placeholder="" style="width:190px">
                <Option v-for="(item, index) in viewTypeList" :value="item.code" :key="index">{{ item.value }}</Option>
              </Select>
          </FormItem>
        </Row>
        <Row>
          <FormItem label="绑定key值：">
            <Input v-model="addObject.showKey"  />
          </FormItem>
        </Row>
        <Row>
          <FormItem label="中文描述：">
            <Input v-model="addObject.chName" />
          </FormItem>
        </Row>
        <Row>
          <FormItem label="英文描述：">
            <Input v-model="addObject.enName" />
          </FormItem>
        </Row>
        <!-- <Row>
          <FormItem label="显示角色：">
            <Input v-model="addObject.beShowRole" />
          </FormItem>
        </Row> -->
        <Row>
          <FormItem label="是否启用：">
            <Checkbox v-model="addObject.beUsed"></Checkbox>
          </FormItem>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" @click="addCancelClose()">取消</Button>
        <Button type="primary" @click="addConfirmSave()">确定</Button>
      </div>
    </Modal>    
  </div>
</template>
  
  <script>
import axios from 'axios'
  export default {
    data() {
      return {
        //新增对象
        addObject:{},
        showInternational:false,
        showAddViewSet:false,
        loading:false,
        plan : '',
        formItem: {
        },
        pageInfo : {
            pageNo : 1,
            pageSize: 10,
        },
        total : 0,
        viewTypeList:[],
        internationalColumns: [
        {
          title: "所属页面",
          key: "viewType",
          align: "center",
          render: (h, params) => {
              return h(
                "span",
                this.viewTypeList.filter(item => item.code==params.row.viewType).map(res => res.value)
                );
            },
        },
        {
          title: "绑定key值",
          key: "showKey",
          align: "center",
        },
        {
          title: "中文描述",
          key: "chName",
          align: "center",
        },
        {
          title: "英文描述",
          key: "enName",
          align: "center",
        },
        // {
        //   title: "显示角色",
        //   key: "beShowRole",
        //   align: "center",
        // },
        {
          title: "是否启用",
          key: "beUsed",
          align: "center",
          render: (h,params)=>{
            let beUsed1 = params.row.beUsed
            if(beUsed1==1){ beUsed1 = "是"}
            else{ beUsed1 = "否"}
            return h("span", beUsed1);
          },
        },
        {
          title: "编辑",
          slot: 'action',
          width: 150,
          align: 'center',
          fixed: 'right'
        },
        ],
        internationalData:[],
        showFormItem:{},
        beUsed:null,
      };
    },
    created() {
        this.initgetData()
        this.getLabel()
    },
    methods: {
      getLabel(){
        axios.post("/International/selectInterViewSetLabel", {}).then((res) => {
            if(res){
              this.viewTypeList = res
            }
        })
      },
      addViewSet(){
        this.showAddViewSet = true
        this.addObject={}
      },
      pageChange(val){
        this.pageInfo.pageNo = val
        this.initgetData()
      },
      initgetData(){
        this.loading=true
        let Obj = {
            viewType : this.formItem.viewType,
            chName : this.formItem.chName,
            enName : this.formItem.enName,
            pageNo : this.pageInfo.pageNo,
            pageSize : this.pageInfo.pageSize,
            flag: "1",
        }
        axios.post("/International/selectInterViewSet", Obj).then((res) => {
            this.internationalData = res.data
            this.total = parseInt(res.pageInfo.total) 
            this.loading=false
        })
      },
      showInternationalOpen(row,index){
        this.showInternational = true
        this.showFormItem.viewType = row.viewType
        this.showFormItem.showKey = row.showKey
        this.showFormItem.chName = row.chName
        this.showFormItem.enName = row.enName
        // this.showFormItem.beShowRole = row.beShowRole
        this.showFormItem.beUsed = row.beUsed == 1 ? true : false
      },
      confirmSave(){
        this.$Modal.confirm({
          title: this.$notice('sureSave'),
          onOk: () => {
              let obj={
                ...this.showFormItem,
                beUsed : this.beUsed = this.showFormItem.beUsed == true ? 1 : 0
              }
              axios.post("/International/updateInterViewSet", obj ).then((res) => {
                this.initgetData()
              })
              this.showInternational = false
          }
        })
      },
      cancelClose(){
        this.showInternational = false
      },
      addConfirmSave(){
        this.$Modal.confirm({
          title: this.$notice('sureSave'),
          onOk: () => {
              let obj={
                ...this.addObject,
                beUsed : this.beUsed = this.addObject.beUsed == true ? 1 : 0
              }
              axios.post("/International/insertInterViewSet", obj ).then((res) => {
                this.initgetData()
                if(res.errorMessage!='绑定key值重复,请确认并重新输入'){
                    this.showAddViewSet = false
                }
              })
             
          }
        })
      },
      addCancelClose(){
        this.showAddViewSet = false
      }
    },
  };
  </script>
    
  <style scoped>
  .formRow {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
  }
  .formCol {
      width: calc((100% - 210px) / 3);
      float: left;
      /* margin-right: 30px; */
  }
  @media screen and (max-width: 640px) {
      .formCol {
          width: 100%;
          margin-right: 0px;
      }
      .photoava {
          margin-top: 0px;
      }
  }
  .bottomBtn {
      margin-top: 20px;
      display: flex;
      justify-content: center;
  }
  .ivu-date-picker {
      width:100%
  }
  .addButton{
    text-align: right;
    padding-bottom: 15px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/InternationalViewSet.vue